import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import FileSaver from "file-saver";
import ExcelJS from "exceljs";
import dateFormat from 'dateformat';
import {
  buildMeasureAveragesRow,
  buildMeasureExportSheet,
} from '../../utils/measureFields';

const ExportXlsx = ({
  user,
  csvData,
  fileName,
  size = "sm",
  permissionSGU,
  className = "",
  variant = "secondary",
}) => {
  const [dataToExport, setDataToExport] = useState(csvData);

  const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];
  const handleGetUnit = (unit) => {
    const result = units.find(item => item._id === unit);
    return result?.name || "--";
  }

  useEffect(() => {
    setDataToExport(csvData);
  }, [csvData]);

  const exportToCSV = async (data, fileName) => {
    const { headers, mappedRows } = buildMeasureExportSheet({
      dataList: data,
      user,
      handleGetUnit,
      dateFormat,
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(1);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0C392E' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    headerRow.height = 30;

    headers.forEach((header, index) => {
      const minWidth = header.length + 20;
      worksheet.getColumn(index + 1).width = minWidth;
    });

    mappedRows.forEach((rowData, rowIndex) => {
      const row = worksheet.addRow(Object.values(rowData));

      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };

        if (cell.col === 4 || cell.col === 5 || cell.col === 6) {
          cell.numFmt = '0.0';
        }

        if (rowIndex % 2 === 0) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF4F4F4' }
          };
        } else {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCAEB8C' }
          };
        }

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    worksheet.addRow([]);

    const averagesRow = worksheet.addRow(
      buildMeasureAveragesRow(headers, data)
    );

    averagesRow.eachCell((cell) => {
      cell.font = { bold: true, size: 12 };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE8F5E9' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' }
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  return (
    <Button
      style={{ width: "100%" }}
      variant={variant}
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        exportToCSV(dataToExport, fileName);
      }}
      disabled={!permissionSGU?.home?.write}
      size={size}
    >
      Download
    </Button>
  );
};

export default ExportXlsx;
